<script setup>
const props = defineProps({
    titulo: {
        type: String,
        required: true,
    },
    descricao: {
        type: String,
        required: false,
        default: '',
    },
});
</script>

<template>
    <div class="grid formgrid p-fluid flex justify-content-between">
        <div class="mb-3 field col-12 lg:col-5 ">
            <p class="m-0 text-900 font-semibold text-base line-height-3 text-900">
                {{props.titulo}}
            </p>
            <p class="text-500 font-normal m-0 text-sm">
                {{props.descricao}}
            </p>
        </div>


        <div class="grid formgrid p-fluid col-12 lg:col-7">
            <slot name="form">
        
            </slot>
        </div>
    </div>
</template>